module.exports = __webpack_public_path__ + "static/media/wabcoLogo.1481c76e.png";